import styled from 'styled-components';

const AdminContainer = styled.div`
  background: #ecf4f9;
  width: 100%;
  // display: flex;
  // justify-content: center;

  .paddingAll {
    padding: 5px 4px;
    width: 22px;
  }

  .showError {
    display: flex;
    align-items: center;
    visibility: visible;
  }

  .hideError {
    display: flex;
    alignitems: center;
    visibility: hidden;
    display: none;
  }

  .borderError {
    border: 1px solid #e8212b !important;
  }

  .disableButton {
    pointer-events: none;
  }
  .enableButton {
    background: #5b36f2;
    color: #ffffff;
  }
  .colorError {
    color: #e8212b;
    font-size: 12px;
  }
`;

const AdminBody = styled.div`
  display: flex;
  padding: 16px;
  @media (min-width: 1280px) {
    width: 1024px;
    margin: 0 auto;
  }
`;

const FormBody = styled.div`
  width: 100%;
  border-radius: 8px;
  background: #ffffff;
  padding-bottom: 40px;

  @media (min-width: 768px) {
    width: 352px;
    min-width: 352px;
    margin: 68px auto;
  }

  @media (min-width: 992px) {
    // margin: 72px 29px 0px 32px;
  }

  @media (min-width: 1280px) {
    margin: 140px 89px 70px 31px;
  }
`;

const FormTitle = styled.div`
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 32px;
  color: #1a055d;
  padding: 40px 40px 16px 40px;
`;

const FormText = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  padding: 16px 40px 2px 40px;
`;

const FormInfo = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #4f6168;
  padding: 2px 40px 16px 40px;
`;

const FormCode = styled.div`
  display: flex;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;
  padding: 16px 0px 2px 40px;
`;

const FormNumber = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f;
  padding-left: 3px;
`;

const FormPlace = styled.div`
  padding: 2px 40px 16px 40px;

  &:focus {
    color: #4318cd;
  }

  &:active {
    color: #4318cd;
  }
  input[type='text']::placeholder {
    color: #7a959f;
  }
`;

const TextUser = styled.input`
  padding: 10px 16px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #161d1f !important;

  &:hover {
    background: #ffffff;
    cursor: pointer;
    border: 1px solid #283044;
  }
`;

const FormContainer = styled.div`
  padding: 8px 0px 0px 40px;
`;

const FormButton = styled.button`
  background: #d5e5f0;
  border-radius: 4px;
  padding: 10px 16px 10px 16px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #8090bb;

  &:hover {
    background: #745ef6;
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }

  &:focus {
    background: #4318cd;
    color: #ffffff;
  }

  &:active {
    background: #4318cd;
    color: #ffffff;
  }
`;

const ImageSimulator = styled.div`
  display: none;

  .mr_icon {
    margin-right: 8px;
  }

  @media (min-width: 992px) {
    display: block;
    margin: 118px 85px 70px 31px;
  }

  @media (min-width: 1280px) {
    display: block;
    width: 100%;
  }
`;

const SimulatorImg = styled.img`
  @media (min-width: 992px) {
    max-width: 455px;
    height: 384px;
  }

  @media (min-width: 1280px) {
    max-width: 544px;
    height: 457.81px;
  }
`;

const CloseContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 5px 0px 67px 0px;
`;

const CloseRow = styled.div`
  display: flex;
  visibility: visible;
  background: #ffffff;
  padding: 10px 16px 10px 18px;
  width: 141px;
  box-shadow: 0px 1.2px 4px #eaeef1;
  border-radius: 4px;
`;

export {
  AdminContainer,
  AdminBody,
  FormBody,
  FormTitle,
  FormText,
  FormInfo,
  FormCode,
  FormNumber,
  FormPlace,
  TextUser,
  FormContainer,
  FormButton,
  CloseContainer,
  CloseRow,
  ImageSimulator,
  SimulatorImg
};
